export const DEBITO_CONTA_CORRENTE_PF_COBRANCA = [
  {
    "numeroDebito": "0003656535001",
    "nomeTributo": "IRPF",
    "codigoReceita": "0211",
    "dataVencimento": [
      2015,
      4,
      29
    ],
    "valorOriginal": "366.11",
    "valorSaldoDevedor": "366.11",
    "unidadeMonetaria": "REAL",
    "codigoSituacaoDebito": "14",
    "situacaoDebito": "DEVEDOR",
    "dataPaExercicio": "2016",
    "inTamanhoProcesso": "1",
    "numeroProcesso": "00000000000000000",
    "inNaturezaDebito": "I",
    "inEmissaoDarf": "S",
    "indTipoDebito": "0",
    "indExibeDarf": true
  },
  {
    "numeroDebito": "0003656535002",
    "nomeTributo": "IRPF",
    "codigoReceita": "0211",
    "dataVencimento": [
      2015,
      5,
      31
    ],
    "valorOriginal": "366.11",
    "valorSaldoDevedor": "366.11",
    "unidadeMonetaria": "REAL",
    "codigoSituacaoDebito": "14",
    "situacaoDebito": "DEVEDOR",
    "dataPaExercicio": "2016",
    "inTamanhoProcesso": "1",
    "numeroProcesso": "00000000000000000",
    "inNaturezaDebito": "I",
    "inEmissaoDarf": "S",
    "indTipoDebito": "0",
    "indExibeDarf": true
  },
  {
    "numeroDebito": "0003656535003",
    "nomeTributo": "IRPF",
    "codigoReceita": "0211",
    "dataVencimento": [
      2016,
      6,
      30
    ],
    "valorOriginal": "366.11",
    "valorSaldoDevedor": "366.11",
    "unidadeMonetaria": "REAL",
    "codigoSituacaoDebito": "14",
    "situacaoDebito": "DEVEDOR",
    "dataPaExercicio": "2016",
    "inTamanhoProcesso": "1",
    "numeroProcesso": "00000000000000000",
    "inNaturezaDebito": "I",
    "inEmissaoDarf": "S",
    "indTipoDebito": "0",
    "indExibeDarf": true
  },
  {
    "numeroDebito": "0003656535004",
    "nomeTributo": "IRPF",
    "codigoReceita": "0211",
    "dataVencimento": [
      2016,
      7,
      29
    ],
    "valorOriginal": "366.11",
    "valorSaldoDevedor": "366.11",
    "unidadeMonetaria": "REAL",
    "codigoSituacaoDebito": "14",
    "situacaoDebito": "DEVEDOR",
    "dataPaExercicio": "2016",
    "inTamanhoProcesso": "1",
    "numeroProcesso": "00000000000000000",
    "inNaturezaDebito": "I",
    "inEmissaoDarf": "S",
    "indTipoDebito": "0",
    "indExibeDarf": true
  },
  {
    "numeroDebito": "0003656535005",
    "nomeTributo": "IRPF",
    "codigoReceita": "0211",
    "dataVencimento": [
      2016,
      8,
      31
    ],
    "valorOriginal": "366.11",
    "valorSaldoDevedor": "366.11",
    "unidadeMonetaria": "REAL",
    "codigoSituacaoDebito": "14",
    "situacaoDebito": "DEVEDOR",
    "dataPaExercicio": "2016",
    "inTamanhoProcesso": "1",
    "numeroProcesso": "00000000000000000",
    "inNaturezaDebito": "I",
    "inEmissaoDarf": "S",
    "indTipoDebito": "0",
    "indExibeDarf": true
  },
  {
    "numeroDebito": "0003656535006",
    "nomeTributo": "IRPF",
    "codigoReceita": "0211",
    "dataVencimento": [
      2016,
      9,
      30
    ],
    "valorOriginal": "366.11",
    "valorSaldoDevedor": "366.11",
    "unidadeMonetaria": "REAL",
    "codigoSituacaoDebito": "14",
    "situacaoDebito": "DEVEDOR",
    "dataPaExercicio": "2016",
    "inTamanhoProcesso": "1",
    "numeroProcesso": "00000000000000000",
    "inNaturezaDebito": "I",
    "inEmissaoDarf": "S",
    "indTipoDebito": "0",
    "indExibeDarf": true
  }
];
